
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.199 15.787l2.049 6.308a.612.612 0 001.106.123l1.147-1.843 2.949 2.99a.778.778 0 001.106 0 .744.744 0 000-1.106l-2.949-2.99 1.843-1.147a.63.63 0 00-.164-1.106l-6.308-2.007a.628.628 0 00-.779.778z","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M17.95.2a2.173 2.173 0 012.171 2.172v11.284a.724.724 0 11-1.447 0V2.372a.724.724 0 00-.724-.724H3.472a.724.724 0 00-.724.724v18.523a.724.724 0 00.724.724h7.239a.724.724 0 010 1.448H3.472A2.174 2.174 0 011.3 20.895V2.372A2.174 2.174 0 013.472.2z"}}),_c('path',{attrs:{"d":"M4.756 6.322a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-4.5a.749.749 0 01-.751-.748zM13.754 9.321a.75.75 0 01-.75.75h-7.5a.75.75 0 010-1.5h7.5a.749.749 0 01.75.749zM13.732 12.32a.749.749 0 01-.749.75H5.507a.75.75 0 010-1.5h7.475a.749.749 0 01.75.748z"}})])
          )
        }
      }
    